<template>
  <div class="select-detail-option" :class="{ 'is-deleted': deleted }">
    <div class="select-detail-option-head">
      <span class="select-detail-option-title" :title="title">{{ title }}</span>
      <span v-if="deleted" class="select-detail-option-tag">已删除</span>
      <span v-if="value" class="select-detail-option-value">{{ value }}</span>
    </div>
    <div class="select-detail-option-meta">
      <span class="select-detail-option-meta-text">{{ meta }}</span>
      <span v-if="extra" class="select-detail-option-extra">{{ extra }}</span>
    </div>
  </div>
</template>

<script>
// 列表筛选下拉的两行选项内容：首行「名称 + 已删除标记 + 右对齐主数值」，
// 次行「次要信息 + 右对齐附加信息」，具体数值由调用方拼好传入。
export default {
  name: 'VSelectOptionDetail',
  props: {
    // 首行左侧名称；过长时省略，悬停看全称
    title: { type: String, default: '' },
    // 首行右侧主数值：代金券面额 / 课次券实际价格
    value: { type: String, default: '' },
    // 次行左侧次要信息：发放方式 / 购买范围与次数、天数
    meta: { type: String, default: '' },
    // 次行右侧附加信息：类型 ID，用于区分同名同价的类型
    extra: { type: String, default: '' },
    // 已删除的历史类型：整体弱化并补「已删除」标记
    deleted: Boolean,
  },
};
</script>

<style scoped>
.select-detail-option {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.select-detail-option-head {
  display: flex;
  align-items: center;
  gap: 8px;
}

.select-detail-option-title {
  min-width: 0;
  overflow: hidden;
  color: #303133;
  font-size: 14px;
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 已删除标记用浅色描边胶囊，比 el-tag 更轻，避免和名称、面额挤在一起 */
.select-detail-option-tag {
  flex: none;
  height: 18px;
  padding: 0 5px;
  border: 1px solid #dcdfe6;
  border-radius: 3px;
  background: #f5f7fa;
  color: #606266;
  font-size: 11px;
  font-weight: normal;
  line-height: 16px;
}

.select-detail-option-value {
  flex: none;
  margin-left: auto;
  color: #303133;
  font-size: 14px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.select-detail-option-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 3px;
  color: #606266;
  font-size: 12px;
  font-weight: normal;
}

.select-detail-option-meta-text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.select-detail-option-extra {
  flex: none;
  margin-left: auto;
  font-variant-numeric: tabular-nums;
}

/* 已删除类型整体弱化，避免历史类型抢注意力 */
.select-detail-option.is-deleted .select-detail-option-title,
.select-detail-option.is-deleted .select-detail-option-value {
  color: #606266;
}

/* 选中项只把主信息标蓝：Element 默认整行变蓝加粗，两行排版下会糊成一片 */
.el-select-dropdown__item.selected .select-detail-option-title,
.el-select-dropdown__item.selected .select-detail-option-value {
  color: #409eff;
}
</style>
